module.exports = "<carousel>\r\n\t<slide *ngFor=\"let viewModel of viewModels\">\r\n\t\t<a routerLink=\"/technologies/{{viewModel.technologyCategoryId}}\" routerLinkActive=\"active\">\r\n\t\t\t<img src=\"{{viewModel.carouselImageUrl}}\">\r\n\t\t</a>\r\n\t</slide>\r\n</carousel>\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/home/home-carousel/home-carousel.component.html
// module id = ./Frontend/src/app/components/home/home-carousel/home-carousel.component.html
// module chunks = main